/* global I18n */

import React from "react"
import parse from "html-react-parser"
import ImageGallery from "../image_gallery/image_gallery"
import ImageGalleryProvider from "../image_gallery/image_gallery_provider"

function ExerciseExplanation({explanation}) {
  if (!explanation) return null

  const options = {
    replace: (node) => {
      if (!node.attribs?.class?.match("image-gallery-container")) return

      const image_slugs = node.attribs["data-image-slugs"].split(",")
      return (
        <ImageGalleryProvider image_slugs={image_slugs}>
          <ImageGallery/>
        </ImageGalleryProvider>
      )
    }
  }

  return (
    <div className="explanation">
      <p className="title">
        {I18n.t("js.embedded_quiz.exam_summary.explanation")}
      </p>
      <div className="content">
        {parse(explanation, options)}
      </div>
    </div>
  )
}

export default ExerciseExplanation
